﻿class Timeline {
    constructor(elm) {
        this.$elm = $(elm);
        this.$boxes = this.$elm.find('.timeline-box');

        this.boxCollapseClass = "timeline-box--isCollapsed";
        this.collapseBoxOnInit = true;

        if (this.collapseBoxOnInit) {
            this.collapseAll();
        }

        this.setEventListeners();
    }

    setEventListeners() {
        this.$boxes.on('click', this.onBoxClick.bind(this));
    }

    open($elm) {
        $elm.removeClass(this.boxCollapseClass);
    }

    collapse($elm) {
        $elm.addClass(this.boxCollapseClass);
    }

    collapseAll() {
        this.$boxes.each((i, elm) => {
            this.collapse($(elm));
        });
    }

    toggle($elm) {
        if ($elm.hasClass(this.boxCollapseClass)) {
            this.open($elm);
        } else {
            this.collapse($elm);
        }
    }

    onBoxClick(event) {
        event.preventDefault();
        var $target = $(event.target).closest('.timeline-box');

        this.toggle($target);
    }
}

export default Timeline;